import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "../Loader/Loader";
import coverImg from "../../images/cover_not_found.jpg";
import "./OtrosDetails.css";
import {FaArrowLeft} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import config from '../../aws-exports';
import { BookContext } from '../../context/books';

const {
    aws_user_files_s3_bucket_region: region,
    aws_user_files_s3_bucket: bucket
} = config

const OtrosDetails = () => {
    const {idDet } = useParams();
    const [loading, setLoading] = useState(false);
    const [otros, setOtros] = useState(null);
    const navigate = useNavigate();
    const { getOtro, idioma } = useContext(BookContext);

    useEffect(() => {
        setLoading(true);

        function formarFecha (dia, mes) {
            let mesEscrito = "";
            switch(idioma) {
                case "español":
                switch (mes) {
                    case 1: mesEscrito = "Enero"; break;
                    case 2: mesEscrito = "Febrero"; break;
                    case 3: mesEscrito = "Marzo"; break;
                    case 4: mesEscrito = "Abril"; break;
                    case 5: mesEscrito = "Mayo"; break;
                    case 6: mesEscrito = "Junio"; break;
                    case 7: mesEscrito = "Julio"; break;
                    case 8: mesEscrito = "Agosto"; break;
                    case 9: mesEscrito = "Septiembre"; break;
                    case 10: mesEscrito = "Octubre"; break;
                    case 11: mesEscrito = "Noviembre"; break;
                    case 12: mesEscrito = "Diciembre"; break;
                    default: break;
                }
                if (dia === 0) {return mesEscrito} 
                    else { return dia + " de " + mesEscrito}
                case "english":
                    switch (mes) {
                        case 1: mesEscrito = "January"; break;
                        case 2: mesEscrito = "February"; break;
                        case 3: mesEscrito = "March"; break;
                        case 4: mesEscrito = "April"; break;
                        case 5: mesEscrito = "May"; break;
                        case 6: mesEscrito = "June"; break;
                        case 7: mesEscrito = "July"; break;
                        case 8: mesEscrito = "August"; break;
                        case 9: mesEscrito = "September"; break;
                        case 10: mesEscrito = "October"; break;
                        case 11: mesEscrito = "November"; break;
                        case 12: mesEscrito = "December"; break;
                        default: break;
                    }
                    if (dia === 0) {return mesEscrito} 
                        else { return mesEscrito + " " + dia}
                default:
                break;
            }
        }

        async function getBookDetails(){
            try{
                const data = await getOtro(idDet);
                if (data){
                    const {titulo, institucion, portada, diaedicion, mesedicion, anoedicion} = data;
                    const newGuia = {
                        titulo: titulo,
                        institucion: institucion,
                        cover_img: formarPortada(portada) ? `https://${bucket}.s3.${region}.amazonaws.com/imgaut/${formarPortada(portada)}`: coverImg,
                        diaymes: formarFecha(diaedicion, mesedicion),
                        anoedicion: anoedicion
                    };
                    setOtros(newGuia);
                } else {
                    setOtros(null);
                }
                setLoading(false);
            } catch(error){
                console.log(error);
                setLoading(false);
            }
        }
        getBookDetails();
    }, [getOtro, idDet, idioma]);

    function formarPortada (cover) {
        let agregar = "g.jpg";
        let buscar = ".jpg";
        let gr1 = cover.split(buscar);
        return gr1[0] + agregar;
    }

    if(loading) return <Loading />;
    switch (idioma) {
      case "español":
    return (
        <section className='otros-details'>
            <div className="container">
                <button type='button' className="flex flex-c back-btn" onClick={() => { setOtros(null); navigate("/otros") } }>
                    <FaArrowLeft size = {22} />
                    <span className="fs-18 fw-6">Atrás</span>
                </button>

                <div className='otros-details-content grid'>
                    <div className='otros-details-img'>
                        <img src = {otros?.cover_img} alt = "cover img" />
                    </div>
                    <div className='otros-details-info'>
                        <div className='otros-details-item title'>
                            <span className='fw-6 fs-24'>{otros?.titulo}</span>
                        </div>
                        <div className='otros-details-item'>
                            <span className='fw-6'>Autor: </span>
                           <span className='text-italic'>{otros?.autor}</span>
                        </div>
                        <div className='otros-details-item'>
                            <span className='fw-6'>Fecha de edición: </span>
                           <span className='text-italic'>{otros?.diaymes + " de " + otros?.anoedicion}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
    case "english":
        return (
            <section className='otros-details'>
                <div className="container">
                    <button type='button' className="flex flex-c back-btn" onClick={() => { setOtros(null); navigate("/otros") } }>
                        <FaArrowLeft size = {22} />
                        <span className="fs-18 fw-6">Back</span>
                    </button>
    
                    <div className='otros-details-content grid'>
                        <div className='otros-details-img'>
                            <img src = {otros?.cover_img} alt = "cover img" />
                        </div>
                        <div className='otros-details-info'>
                            <div className='otros-details-item title'>
                                <span className='fw-6 fs-24'>{otros?.titulo}</span>
                            </div>
                            <div className='otros-details-item'>
                                <span className='fw-6'>Author: </span>
                               <span className='text-italic'>{otros?.autor}</span>
                            </div>
                            <div className='otros-details-item'>
                                <span className='fw-6'>Edition's date: </span>
                               <span className='text-italic'>{otros?.diaymes + ", " + otros?.anoedicion}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
        default:
         break;
    }
}

export default OtrosDetails;